<template>
    <div class="sm:col-span-12">
        <div>
            <FormLabel :value="$t('messages.number')" for="number" />
            <FormInput
                id="number"
                v-model.number="form.number"
                name="number"
                @keypress.enter.prevent
                :placeholder="$t('messages.number')"
                type="number"
                required
                step="any"
                class="mt-1 w-40"
            />
            <FormError :value="errors[`options.number`]" class="mt-2" />
        </div>
    </div>
</template>

<script>
import FormLabel from '@/components/Forms/FormLabel.vue';
import FormInput from '@/components/Forms/FormInput.vue';
import FormError from '@/components/Forms/FormError.vue';

export default {
    name: 'QuestionMathPrimeFactorsOptions',
    components: {
        FormLabel,
        FormInput,
        FormError,
    },
    props: {
        modelValue: {
            required: true,
        },
        errors: {
            required: true,
        },
    },
    emits: ['update:modelValue'],
    data() {
        return {
            form: this.modelValue,
        };
    },
    watch: {
        form(newVal) {
            this.$emit('update:modelValue', newVal);
        },
    },
    mounted() {
        let defaultOptions = {
            number: '',
        };
        if (!this.form.hasOwnProperty('number')) {
            Object.entries(defaultOptions).forEach((entry) => (this.form[entry[0]] = entry[1]));
        }
    },
};
</script>
